<mat-toolbar *ngIf="hasTasks()" color="primary" class="queue-bar" [ngClass]="{ 'queue-bar--resolved': isResolved() }">
  <div class="task-count-column">
    <mat-icon>assignment_turned_in</mat-icon>
    <span class="task-count">
      <span class="task-count--label">{{ 'TASK_QUEUE.TASKS' | translate }}</span>
      <span *ngIf="taskQueue() as taskQueue">({{ taskQueue.current + 1 }}/{{ taskQueue.tasks.length }})</span>
    </span>
  </div>
  <div class="task-title-column">
    <ng-container>
      <span class="task-title">{{ currentTaskName() }}</span>
      <span *ngIf="currentAssociations() as associations">
        <mat-chip
          *ngIf="associations.length > 1; else oneAssociation"
          class="task-associations"
          [matMenuTriggerFor]="menu"
        >
          {{
            'TASK.LIST_OBJECTS_TABLE.ACTIONS.TASK_QUEUE.ASSOCIATIONS_CHIP' | translate: { count: associations.length }
          }}
          <mat-icon matChipTrailingIcon>arrow_drop_down</mat-icon>
          <mat-menu #menu="matMenu">
            <span *ngIf="currentPageId$ | async as pageId">
              <button
                *ngFor="let association of associations"
                [ngClass]="{ 'association-selected': association.association.crmObjectId === pageId }"
                mat-menu-item
                (click)="changeAssociation(association.association)"
              >
                {{ association.name }}
              </button>
            </span>
          </mat-menu>
        </mat-chip>
        <ng-template #oneAssociation>
          <mat-chip
            *ngIf="associations.length === 1"
            (click)="changeAssociation(associations[0].association)"
            class="task-associations"
          >
            <span class="task-associations--name">{{ associations[0].name }}</span>
          </mat-chip>
        </ng-template>
      </span>
    </ng-container>
  </div>
  <div class="actions-column">
    <ng-container *ngIf="isResolved(); then resolvedActions; else actions"></ng-container>
    <button mat-icon-button (click)="handleEmptyClick()"><mat-icon>close</mat-icon></button>
  </div>
</mat-toolbar>

<ng-template #actions>
  <ng-container *ngIf="!updateTaskLoadingStatus(); else isLoading">
    <crm-reschedule-task
      #rescheduleTask
      [task]="currentTask()"
      (handleReschedule)="handleReschedule($event)"
    ></crm-reschedule-task>
    <button
      *ngIf="hasPendingTasks()"
      mat-stroked-button
      class="button"
      [disabled]="loading()"
      (click)="handleSkipClick()"
    >
      <mat-icon>skip_next</mat-icon>
      {{ 'TASK_QUEUE.ACTIONS.SKIP' | translate }}
    </button>
    <button
      mat-flat-button
      class="button primary-action--open"
      (click)="handleCompleteClick()"
      [disabled]="updateTaskLoadingStatus()"
    >
      <mat-icon class="check">check</mat-icon>
      {{ 'TASK_QUEUE.ACTIONS.MARK_AS_COMPLETE' | translate }}
    </button>
  </ng-container>
</ng-template>

<ng-template #resolvedActions>
  <ng-container *ngIf="!updateTaskLoadingStatus(); else isLoading">
    <span class="action-done-column">
      <mat-icon class="check">check</mat-icon>
      <ng-container [ngSwitch]="action()?.type">
        <ng-container *ngSwitchCase="'reschedule'">
          {{ 'TASK_QUEUE.STATUS.RESCHEDULED' | translate }}
        </ng-container>
        <!-- Defaults to Completed in case the Task was completed before showing in the queue -->
        <ng-container *ngSwitchDefault>
          {{ 'TASK_QUEUE.STATUS.COMPLETED' | translate }}
        </ng-container>
      </ng-container>
    </span>

    <button
      *ngIf="action()?.undoRequest"
      mat-stroked-button
      class="button"
      (click)="handleUndoClick()"
      [disabled]="updateTaskLoadingStatus()"
    >
      {{ 'TASK_QUEUE.ACTIONS.UNDO' | translate }}
    </button>

    <button
      *ngIf="hasPendingTasks()"
      mat-flat-button
      class="button primary-action--resolved"
      (click)="handleNextClick()"
    >
      {{ 'TASK_QUEUE.ACTIONS.NEXT' | translate }}
    </button>
    <button
      *ngIf="!hasPendingTasks()"
      mat-flat-button
      class="button primary-action--resolved"
      (click)="handleBackToTasksClick()"
    >
      {{ 'TASK_QUEUE.ACTIONS.BACK_TO_TASKS' | translate }}
    </button>
  </ng-container>
</ng-template>

<ng-template #isLoading>
  <mat-progress-spinner class="loading-spinner--white" diameter="24" mode="indeterminate"></mat-progress-spinner>
</ng-template>
